var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.995,
    height: 16,
    viewBox: "0 0 15.995 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "login",
    d: "M3.2,12.479a.8.8,0,0,1,1.072.36,6.4,6.4,0,1,0,0-5.679.8.8,0,1,1-1.44-.72,8,8,0,1,1,0,7.119.8.8,0,0,1,.368-1.08ZM2.8,9.2h7.671L8.636,7.367A.8.8,0,1,1,9.772,6.231l3.2,3.2a.827.827,0,0,1,0,1.136l-3.2,3.2a.8.8,0,1,1-1.136-1.136l1.84-1.832H2.8a.8.8,0,0,1,0-1.6Z",
    transform: "translate(-2.005 -1.999)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.30db2d34a669d66be4a6372544c3ba22.svg";
export { ForwardRef as ReactComponent };